import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import MuiAlert from '@mui/material/Alert';

import {usePlayContext} from '../utils/PlayContext';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const SnackToast = ()=>{

  const {   snackOpen, setSnackOpen,
            snackMessage, 
            snackSeverity,
      }=usePlayContext();

  const handleClose = ()=>{
    setSnackOpen(false)
  }
      
  return    (
    <Snackbar   open={snackOpen} 
                autoHideDuration={7000}
                anchorOrigin={{ vertical:'top', horizontal:'right' }} 
                TransitionComponent={Slide}

            onClose={handleClose}>
          <Alert onClose={handleClose} severity={snackSeverity} 
              sx={{ width: '100%' }}>
              {snackMessage}
          </Alert>
    </Snackbar>
  )   
}

export default SnackToast;